import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Grid, TextField, Button, MenuItem,
  FormControl, InputLabel, Select,
  useMediaQuery, useTheme
} from '@mui/material';

export default function ExpenseFormDialog({
  open, onClose, onSubmit,
  editMode, formData, setFormData,
  canManageExpenses, currentExpense,
  expenseTypes
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      aria-labelledby="expense-dialog-title"
      onKeyDown={(e) => {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
          e.preventDefault();
          onSubmit();
        }
      }}
    >
      <DialogTitle id="expense-dialog-title">{editMode ? 'Edit Expense' : 'New Expense Request'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              value={formData.start_date}
              onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
              size={isMobile ? 'small' : 'medium'}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="End Date"
              value={formData.end_date}
              onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
              size={isMobile ? 'small' : 'medium'}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
              <InputLabel>Expense Type</InputLabel>
              <Select
                value={formData.expense_type}
                label="Expense Type"
                onChange={(e) => setFormData({ ...formData, expense_type: e.target.value })}
              >
                {expenseTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Title"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              placeholder="e.g., Client visit to NYC, Office supplies"
              size={isMobile ? 'small' : 'medium'}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Provide details about this expense..."
              size={isMobile ? 'small' : 'medium'}
            />
          </Grid>
          {canManageExpenses && editMode && currentExpense && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={2}
                label="Manager Notes"
                value={formData.manager_notes || currentExpense.manager_notes || ''}
                onChange={(e) => setFormData({ ...formData, manager_notes: e.target.value })}
                placeholder="Add notes for the employee..."
                size={isMobile ? 'small' : 'medium'}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: isMobile ? 2 : 1 }}>
        <Button onClick={onClose} size={isMobile ? 'large' : 'medium'}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit} disabled={!formData.title || !formData.start_date} size={isMobile ? 'large' : 'medium'}>
          {editMode ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
